<template>
	<div class="c-ai-clone">
		<header>
			<h3>Ai clone</h3>
			<p>
				<strong>How does it work? </strong>
			</p>
			<ul>
				<li>Enter your product images + some basic info about your brand</li>
				<li>Press the generate button and wait for a few seconds</li>
			</ul>
		</header>
		<div class="c-ai-clone__grid">
			<div class="c-ai-clone__left">
				<span class="c-ai-clone__byline"> Source ad </span>
				<Item v-if="ad" :ad="ad"></Item>
			</div>
			<div class="c-ai-clone__middle">
				<span class="c-ai-clone__byline"> Your product + brand info </span>
				<FormAiClone v-if="ad" :adId="ad.id"></FormAiClone>
			</div>
			<div class="c-ai-clone__right">
				<span class="c-ai-clone__byline"> Generated ads </span>
				<button class="btn">Generate</button>
			</div>
		</div>
	</div>
</template>

<script>
import Item from '@swipekit/components/item';
import FormAiClone from '@swipekit/components/form/form-ai-clone';

export default {
	components: {
		Item,
		FormAiClone,
	},

	props: {
		ad: {},
	},
};
</script>

<style lang="scss">
.c-ai-clone {
	header {
		padding: 1rem;

		p,
		li,
		.p {
			margin-bottom: 0.5rem;
		}
		ul {
			margin-top: 0;
		}
	}

	&__byline {
		display: block;
		padding: 0.25rem 0.5rem;
		border-bottom: var(--color-bg-5) solid 2px;
		font-weight: 500;
		line-height: 1;
	}

	&__grid {
		display: grid;
		height: 100%;
		grid-template-columns: 1fr 1fr 1fr;
	}

	&__left {
		height: 100%;
		border-right: var(--color-bg-5) solid 2px;

		> div {
			margin: 0 auto;
			margin-top: var(--spacer-sm);
		}
	}

	&__middle {
		border-right: var(--color-bg-5) solid 2px;
	}

	&__right {
		height: 100%;
		overflow-x: auto;
		position: relative;

		h2 {
			font-size: var(--font-size-lg);
		}
	}

	&__form {
		padding: var(--spacer-sm);
	}
}
</style>
